import React, { useState, useRef } from 'react';

import defaultImage from '../../../images/happy-birthday-cake-2020.jpg';

import "./styles.sass";

import { TwitterPicker } from 'react-color';
import Tabs from '../../Tabs/Tabs';
import TextEditor from '../../Editor/TextEditor';

import { FaChevronRight } from 'react-icons/fa';
import BannerEditorButton from './banner-editor-button';
import { S3Image } from 'aws-amplify-react'

import { v4 as uuid } from 'uuid';

export const ClassicBannerDefaultData = {
    titleHtml: '<p><span style="color: rgb(255,255,255);"><strong>Banner Title</strong></span></p>',
    subtitleHtml: '<p><span style="color: rgb(255,255,255);">Banner Subtitle</span></p>',
    bannerBgColor: 'lightpink',
    bannerBgImage: '',
    image: {
        url: defaultImage,
        borderClass: "is-circle",
        s3Key: ''
    }
}

const ClassicBanner = (props) => {
    const { data = { ...ClassicBannerDefaultData }, readonly = true, showEditorOnOpen = false } = props;

    const [showMenu, setShowMenu] = useState(!readonly && showEditorOnOpen);
    const [selectedTab, setSelectedTab] = useState(0)

    const [titleHtml, setTitleHtml] = useState(data.titleHtml);
    const [subtitleHtml, setSubtitleHtml] = useState(data.subtitleHtml);
    const [bannerBgColor, setBannerBgColor] = useState(data.bannerBgColor);
    const [bannerBgImage, setBannerBgImage] = useState(data.bannerBgImage);

    const [image, setImage] = useState({ url: data.image?.url, uploadedFile: null, s3Key: data.image?.s3Key })
    const [imageBorderClass, setImageBorderClass] = useState(data.image?.borderClass)

    const inputFile = useRef(null)
    const backgroundImageURLForm = useRef(null)

    const handleImageChange = (e) => {
        setImage({
            url: URL.createObjectURL(e.target.files[0]),
            uploadedFile: e.target.files[0],
            s3Key: ''
        })
    }

    const openEditor = (tabIndex) => {
        if (readonly) return
        if (!showMenu) setShowMenu(true);
        if (selectedTab !== tabIndex) setSelectedTab(tabIndex)
    }

    const closeEditor = () => {
        if (readonly) return
        if (showMenu) setShowMenu(false);
    }

    const handleEditorChange = () => {
        if (readonly) return

        let s3Key = ''
        let images = []

        if (image.uploadedFile) {
            const extension = image.uploadedFile.name.split('.').pop();
            s3Key = `${uuid()}.${extension}`
            images.push({ file: image.uploadedFile, s3Key: s3Key })
        }

        return props.onChange({
            layout: 'classic',
            config: {
                titleHtml: titleHtml,
                subtitleHtml: subtitleHtml,
                bannerBgColor: bannerBgColor,
                bannerBgImage: bannerBgImage,
                image: {
                    url: !image.uploadedFile ? image.url : '',
                    s3Key: s3Key,
                    borderClass: imageBorderClass
                }
            },
            images: images
        });
    }

    const Picture = ({s3IdentityId}) => {
        if (image.url) {
            return <img className={`profile-picture my-2 ${imageBorderClass}`} src={image.url} alt="" />
        } else if (image.s3Key) {
            return <S3Image level="protected"             
                identityId={s3IdentityId}
                imgKey={image.s3Key} 
                className={`profile-picture my-2 ${imageBorderClass}`} />
        }
    }

    const bannerBackground = () => {
        if (bannerBgImage && bannerBgImage !== '') {
            return `url(${bannerBgImage})`
        }
        return bannerBgColor
    }

    return (
        <>
            <section className={`hero is-bold has-background-cover ${props.compact ? '' : 'section'} ${props.heroClassName ? props.heroClassName : ''}`}
                style={{ background: bannerBackground() }}>
                <div id="container">
                    <div className='py-4 has-text-centered'>
                        <h1 className='banner-title is-size-3' onClick={() => openEditor(1)} dangerouslySetInnerHTML={{ __html: titleHtml }}></h1>
                        <h2 className='banner-subtitle is-size-6 my-4' onClick={() => openEditor(2)} dangerouslySetInnerHTML={{ __html: subtitleHtml }}></h2>
                        {
                            !props.titleOnly &&
                            <div className="pt-6 pb-6" onClick={() => openEditor(3)}>
                                <Picture s3IdentityId={data.s3IdentityId} />
                            </div>
                        }
                    </div>

                </div>
            </section>

            {readonly ? null :
                <>
                    <BannerEditorButton onClickEditor={() => openEditor(0)} />

                    <div className={showMenu ? "banner-menu has-background-white is-show-menu" : "banner-menu is-hide-menu"}>
                        <div className="message-header mt-1 mb-4 is-size-4 py-2 has-text-black has-background-white has-border-bottom-grey">
                            <p className="has-text-centered has-fullwidth">Classic</p>
                            <button className="button is-small" onClick={() => closeEditor()}>
                                <FaChevronRight />
                            </button>
                        </div>

                        <div className="action-button px-4 pb-4">
                            <button className="button has-text-weight-bold is-fullwidth is-primary" onClick={() => handleEditorChange()} >Create</button>
                        </div>

                        <Tabs tabClassName="px-4 has-text-centered is-small is-toggle is-fullwidth is-marginless"
                            tabContentClassName="px-1 py-1 tab-box"
                            selectedTab={selectedTab}
                            onChange={index => setSelectedTab(index)}>

                            <div title="Background">
                                <div>
                                    <p className="has-text-grey is-size-6 has-text-centered my-1 is-small-caps">
                                        SOLID COLOR
                                    </p>
                                    <TwitterPicker triangle="hide" onChangeComplete={(color) => {
                                        setBannerBgColor(color.hex)
                                        setBannerBgImage('')
                                    }} />
                                </div>
                                <div className="pt-3">
                                    <p className="has-text-grey is-size-6 has-text-centered my-1 is-small-caps">
                                        Image Link
                                    </p>

                                    <div className="box mx-1 field has-addons">
                                        <p className="control">
                                            <form ref={backgroundImageURLForm}>
                                                <input className="input" type="text" placeholder="URL"
                                                    name="url" />
                                            </form>
                                        </p>
                                        <p className="control">
                                            <button className="button" onClick={() => {
                                                setBannerBgImage(backgroundImageURLForm.current.url.value)
                                            }}>
                                                <span>OK</span>
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div title="Title">
                                <div style={{ background: bannerBgColor }} className="px-1 py-1">
                                    <TextEditor initialValue={titleHtml} onChange={(c) => setTitleHtml(c)} />
                                </div>
                            </div>

                            <div title="Subtitle">
                                <div style={{ background: bannerBgColor }} className="px-1 py-1">
                                    <TextEditor initialValue={subtitleHtml} onChange={(c) => setSubtitleHtml(c)} />
                                </div>
                            </div>

                            <div title="Picture">
                                <label className="is-hidden">
                                    <input className="file-input" ref={inputFile} type="file" accept="image/*" onChange={handleImageChange} />
                                </label>


                                <div className="buttons has-addons is-centered mb-1 mt-4">
                                    <button className={`button is-small ${imageBorderClass === 'is-circle' ? 'is-success is-selected' : ''}`} onClick={() => setImageBorderClass("is-circle")}>Circle</button>
                                    <button className={`button is-small ${imageBorderClass === 'is-rectangle' ? 'is-success is-selected' : ''}`} onClick={() => setImageBorderClass("is-rectangle")}>Rectangle</button>
                                    <button className={`button is-small ${imageBorderClass === 'is-rounded' ? 'is-success is-selected' : ''}`} onClick={() => setImageBorderClass("is-rounded")}>Rounded</button>
                                </div>

                                <div className="file-preview has-text-centered px-4" style={{ background: bannerBgColor }} onClick={() => inputFile.current.click()}>
                                    <Picture s3IdentityId={data.s3IdentityId} />
                                </div>

                            </div>
                        </Tabs>
                    </div>
                </>
            }
        </>
    );
}

export default ClassicBanner
